import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, HostListener, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-multiselect-list',
  templateUrl: './checkbox-multiselect-list.component.html'
})
export class MultiSelectListComponent implements OnInit, OnChanges {
  private _itemsList: Array<any>;
  public selectedAll: boolean = false;

  get itemsList(): Array<any> { return this._itemsList; }
  @Input() set itemsList(items: Array<any>) {
    this._itemsList = items;
  }

  @Input() selectedData;
  private _selectedItem: UntypedFormGroup;

  get selectedItem(): UntypedFormGroup { return this._selectedItem; }
  @Input() set selectedItem(item: UntypedFormGroup) {
    this._selectedItem = item;

    if (this._selectedItem.disabled) {
      this.inputItem.disable();
    } else {
      this.inputItem.enable();
    }
  }

  @Input() disabled: Subject<boolean>;

  @Output() shareCheckedList = new EventEmitter();
  @Output() shareIndividualCheckedList = new EventEmitter();

  @Input() set initialState(state: string) {
    if (state === 'allSelected') {
      this.selectUnselectAll();
    }
  };

  private _inputItem: UntypedFormGroup;

  get inputItem(): UntypedFormGroup { return this._inputItem; }
  set inputItem(item: UntypedFormGroup) {
    this._inputItem = item;
  };

  public showList = false;
  private showInput = '';
  checkedList: any[] = [];
  currentSelected: {};

  @Input() selectSpecificItems?: boolean = false; // Para que al inicio se puedan marcar varios elementos (antes de que el usuario interactúe con el form)
  @Input() specificItemsToSelect?: Array<any> = [];

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.showList = false;
    }
  }

  constructor(private _fb: UntypedFormBuilder, private eRef: ElementRef, private _translate: TranslateService) {
    this.inputItem = this._fb.group({
      id: [''],
      des: ['']
    });
  }

  ngOnInit() {
    this.checkedList = null;
    this.showInput = '';
    this.inputItem.reset();

    this.selectedItem.valueChanges.subscribe(() => {
      if (this.selectedItem && !this.selectedItem.value) {
        this.inputItem.reset();
        this.checkedList = null;
        this.showInput = '';
        this.selectedAll = false;
      }

      if (this.selectedItem && this.selectedItem.validator) {
        this.inputItem.get('des').setValidators(this.selectedItem.validator);
        this.inputItem.updateValueAndValidity();
      }
    });

    if (this.disabled) {
      this.disabled.subscribe(disable => {
        if (disable) {
          this.inputItem.disable();
        } else {
          this.inputItem.enable();
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Si hay elementos a marcar
    if (changes['specificItemsToSelect'] && this.selectSpecificItems && this.specificItemsToSelect.length > 0) {
      this.selectSpecificItemsFromAPI();
      // Si no los hay
    } else if (changes['specificItemsToSelect'] && this.selectSpecificItems && this.specificItemsToSelect.length === 0) {
      this.selectedAll = false;
      this.checkedList = [];
      
      // Asegurar la limpieza del texto "Todos los elementos seleccionados"
      if (this.itemsList && this.itemsList.length > 0) {
        // No lo habilitamos porque al inicio habrá campos que necesiten estar bloqueados. Mejor controlar esto en el padre
        this.inputItem.patchValue({
          des: ''
        });
      }
    }
  }

  private selectSpecificItemsFromAPI() {
    this.checkedList = [];
    this.showInput = '';

    this.specificItemsToSelect.forEach(itemToSelect => {
      const foundItem = this.itemsList.find(item => item.id === itemToSelect || item.id_aux === itemToSelect);
      if (foundItem) {
        this.checkedList.push(foundItem.hasOwnProperty('id_aux') ? foundItem.id_aux : foundItem.id);
        this.showInput = this.showInput === '' ? foundItem.des : this.showInput + ', ' + foundItem.des;

        // Si se marcan todos los elementos de la lista
        if (this.checkedList.length > 1 && this.checkedList.length === this.itemsList.length) {
          this.inputItem.enable();
          this.selectedAll = true;
          this.inputItem.patchValue({
            des: this._translate.instant('global.todosSeleccionados')
          });
          // Si la lista solo tiene 1 elemento y este se marca 
        } else if (this.checkedList.length === 1 && this.checkedList.length === this.itemsList.length) {
          this.inputItem.disable();
          this.selectedAll = true;
          this.inputItem.patchValue({
            des: this.showInput
          });
          // Si hay mínimo un elemento marcado, pero la lista tiene más elementos
        } else if (this.checkedList.length >= 1 && this.checkedList.length < this.itemsList.length) {
          this.inputItem.enable();
          this.selectedAll = false;
          this.inputItem.patchValue({
            des: this.showInput
          });
        }
      }
    });

    this.shareCheckedlist();
  }

  public setDisable(disable) {
    if (disable) {
      this.inputItem.disable();
    } else {
      this.inputItem.enable();
    }
  }

  selectItem(item, clickEvent) {
    clickEvent.preventDefault();
    if (!this.checkedList) {
      this.checkedList = [];
    }
    const checkBox = document.getElementById('ck' + item.id) as HTMLInputElement;
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      item.hasOwnProperty('id_aux') ? this.checkedList.push(item.id_aux) : this.checkedList.push(item.id);
      this.showInput = this.showInput == '' ? item.des : this.showInput + ', ' + item.des;
      this.inputItem.patchValue({
        des: this.showInput
      });

      if (this.checkedList.length === this.itemsList.length) {
        this.selectUnselectAll();
      }

    } else {
      var i = item.hasOwnProperty('id_aux') ? this.checkedList?.indexOf(item.id_aux) : this.checkedList?.indexOf(item.id);
      this.checkedList.splice(i, 1);
      this.showInput = this.showInput.includes(item.des + ', ') ? this.showInput.replace(item.des + ', ', '') : this.showInput.replace(item.des, '');
      if (this.showInput.substring(this.showInput.length - 2) == ', ') {
        this.showInput = this.showInput.slice(0, -2);
      }
      this.inputItem.patchValue({
        des: this.showInput
      });

      if (this.checkedList.length === 0) {
        this.checkedList = null;
      }
    }

    this.shareCheckedlist();
  }

  shareCheckedlist() {
    this.shareCheckedList.emit(this.checkedList);
  }

  public getPlaceholder() {
    let placeholder = '';

    if (this.itemsList) {
      if (this.itemsList.length > 1) {
        placeholder = this.itemsList[0].des + ',' + ' ' + this.itemsList[1].des + '...';
      } else {
        placeholder = this.itemsList[0] ? this.itemsList[0].des : ' ';
      }
    }
    return placeholder;
  }

  public startComponent() {
    this.showList = !this.showList;
  }

  public selectUnselectAll(clickEvent?) {
    clickEvent?.preventDefault();
    this.selectedAll = clickEvent ? !this.selectedAll : true;
    this.checkedList = null;
    this.showInput = '';
    this.inputItem.patchValue({
      des: ''
    });

    if (this.selectedAll) {
      this.checkedList = [];
      this.itemsList.forEach(item => {
        item.hasOwnProperty('id_aux') ? this.checkedList.push(item.id_aux) : this.checkedList.push(item.id);
        this.showInput = this.showInput == '' ? item.des : this.showInput + ', ' + item.des;
      });
      this.inputItem.patchValue({
        des: this.itemsList.length > 1 ? this._translate.instant('global.todosSeleccionados') : this.showInput
      });
    }

    this.shareCheckedlist();
  }
}
